import { createClient } from "@supabase/supabase-js";

// These variables are safe to expose in your Expo app since Supabase has Row Level Security enabled on our Database.
const supabaseUrl = "https://ajxjsnuynuxigljdrsyk.supabase.co";
const supabaseAnonKey =
	"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImFqeGpzbnV5bnV4aWdsamRyc3lrIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MTM3NDg0MTksImV4cCI6MjAyOTMyNDQxOX0.pxYXUpOhStDaucb8KmIIXqGhLSWCriIGSnf_pRs3Mfk";

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {});
